module.exports = __webpack_public_path__ + "img/ppe_sample.2c19242b.png";